import { SimpleSubRoute } from 'authorization';

export class ThemeRoute {
  static readonly map = {
    test: new SimpleSubRoute(),
    card: new SimpleSubRoute(),
  };
}
